import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Coins, Infinity as InfinityIcon } from "@phosphor-icons/react";

export default function CreditBadge({ compact }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;
  const total = (user.credits || 0) + (user.topup_credits || 0);

  return (
    <button
      data-testid="credit-badge"
      onClick={() => navigate("/billing")}
      className="flex items-center gap-1.5 border border-forge-border px-3 py-1.5 rounded-sm hover:border-forge-primary hover:bg-forge-hover transition-colors group"
      title="Manage credits & plan"
    >
      {user.unlimited ? (
        <>
          <InfinityIcon size={16} weight="bold" className="text-forge-primary" />
          <span className="text-sm font-mono text-forge-primary">Unlimited</span>
        </>
      ) : (
        <>
          <Coins size={15} weight="fill" className="text-forge-primary" />
          <span className="text-sm font-mono text-white">{total}</span>
          {!compact && <span className="text-xs text-neutral-500 font-mono">credits</span>}
        </>
      )}
    </button>
  );
}
